"use client";

type StatusPopUpProps = {
    title: string;
    message: string;
    onClose: () => void;
    type?: "info" | "success" | "error";
};

export default function StatusPopUp({ title, message, onClose, type = "info" }: StatusPopUpProps) {
    const buttonClass =
        type === "success"
            ? "bg-[#0a9cf0]"
            : type === "error"
                ? "bg-[#D9534F]"
                : "bg-[#4E4E4E]";

    return (
        <div className="fixed inset-0 z-60 flex items-center justify-center bg-black/45 p-4">
            <div className="w-full max-w-100 rounded-md bg-[#f3f3f3] px-5 pb-8 pt-7 shadow-[0_6px_20px_rgba(0,0,0,0.35)]">
                <div className="mx-auto w-70 rounded-sm border border-[#FDEF5C] bg-[#FDEF5C] py-1 text-center text-lg font-semibold text-[#2B2B2B] shadow-[4px_4px_0_#5d6670]">
                    {title}
                </div>

                <p className="mt-6 text-center text-base text-[#4E4E4E]">{message}</p>

                <div className="mt-7 flex justify-center">
                    <button
                        type="button"
                        onClick={onClose}
                        className={`min-w-20 cursor-pointer rounded-md px-7 py-2 text-base font-semibold text-white ${buttonClass}`}
                    >
                        ตกลง
                    </button>
                </div>
            </div>
        </div>
    );
}
